var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColteneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.832,
    height: 42.616,
    viewBox: "0 0 57.832 42.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coltene_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5273",
    "data-name": "Group 5273",
    transform: "translate(-1 -115.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5284",
    "data-name": "Group 5284",
    transform: "translate(1 115.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5283",
    "data-name": "Group 5283",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M11.631,11.3,2.22,31.129H14.584l9.4-19.828Z",
    transform: "translate(2.596 11.487)",
    fill: "#00a4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M18.832,11.3,9.42,31.129H21.785l9.4-19.828Z",
    transform: "translate(11.018 11.487)",
    fill: "#57c1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M26.033,11.3,16.621,31.129H28.986L38.391,11.3Z",
    transform: "translate(19.441 11.487)",
    fill: "#acdefa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M9.412.8,0,20.628H12.365L21.768.8Z",
    transform: "translate(0 -0.798)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M16.612.8,7.2,20.628H19.565L28.968.8Z",
    transform: "translate(8.422 -0.798)",
    fill: "#0090df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M23.814.8,14.4,20.628H26.767L36.172.8Z",
    transform: "translate(16.845 -0.798)",
    fill: "#0090df"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColteneIcon);
export default __webpack_public_path__ + "static/media/coltene_icon.2197bca7a9c8ad1d9a605f009da885da.svg";
export { ForwardRef as ReactComponent };